import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext"; 
import API from "../../services/api";  
import { t } from "@lingui/macro";

const MyReservations = () => {
  const [reservations, setReservations] = useState([]);
  const { authToken } = useAuth(); 

  useEffect(() => {
    if (authToken) {
      API.get("/api/users/reservations") 
        .then((response) => setReservations(response.data))
        .catch((error) => console.error("Error fetching reservations:", error));
    }
  }, [authToken]); 

  const handleDownload = (reservationId) => {
    console.log("Chcemy pobrac bilet o id " + reservationId);
    API.get(`/api/users/reservations/${reservationId}/download`, { responseType: "blob" }) 
      .then((response) => {
        console.log("Response status:", response.status); 
        if (response.status !== 200) { 
          throw new Error("Download failed.");
        }
        return response.data; 
      })
      .then((blob) => {
        console.log("Blob size:", blob.size); 
        const link = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = `${reservationId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); 
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };

  return (
    <div>
      <h2>{t`My Reservations`}</h2>
      <p>{t`View and manage your active reservations.`}</p>
      
      <div className="reservations-list">
        {reservations.length === 0 ? (
          <p>{t`No active reservations found.`}</p>
        ) : (
          <ul>
            {reservations.map((reservation) => (
              <li key={reservation.id}>
                <div className="reservation-item">
                  <p>
                    <strong>{t`Reservation ID:`}</strong> {reservation.id}
                  </p>
                  <p>
                    <strong>{t`Start Date:`}</strong>{" "}
                    {new Date(reservation.startDate).toLocaleDateString("pl-PL")}
                  </p>
                  <p>
                    <strong>{t`End Date:`}</strong>{" "}
                    {new Date(reservation.endDate).toLocaleDateString("pl-PL")}
                  </p>
                  <p>
                    <strong>{t`Total Amount:`}</strong> ${reservation.totalAmount}
                  </p>
                  <p>
                    <strong>{t`Paid:`}</strong> ${reservation.paidAmount}
                  </p>
                  <p>
                    <strong>{t`Remaining:`}</strong> ${reservation.remainingAmount}
                  </p>

                  <div>
                    <h4>{t`Rooms:`}</h4>
                    <ul>
                      {Object.entries(reservation.rooms).map(([roomType, count]) => (
                        <li key={roomType}>
                          {roomType}: {count}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <button
                    onClick={() => handleDownload(reservation.id)}
                    className="download-btn"
                  >
                    {t`Download PDF`}
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MyReservations;
